module.exports = __webpack_public_path__ + "static/media/hospital-alt.0787f30d.svg";